// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = 'CALL_API';
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';



// WEBPACK FOOTER //
// ./src/constants/common.js